



















































































import { Component, Prop, Inject, Vue, Watch } from "vue-property-decorator";
import AllConfigurationImages from "@/components/app/images/administration/all-configuration-images.vue";
import UploadPicture from "@/components/app/images/upload-picture.vue";
import StandartModal from "@/components/app/standart-modal.vue";

import { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
import { deleteImages } from "@/api/delite/delite-element";
import { pics } from "@/config/host.config";

@Component({
  components: {
    StandartModal,
    AllConfigurationImages,
    UploadPicture,
  },
})
export default class BackgroundConfig extends Vue {
  @Prop({ type: String, default: "" }) image!: string;
  @Prop({ type: Number, default: 16 / 9 }) aspectRatio!: number;
  @Inject({ from: "backgroundFolder", default: "" }) readonly folder!: string;

  images: Array<string> = [];
  background = this.image;

  @Watch("image")
  onImageChange(newVal: string): void {
    this.background = newVal;
  }

  isOk(): void {
    this.$emit("changeBackground", this.background);
  }

  deleteBgImages(id: string): void {
    deleteImages(id, this.folder).then(() => {
      this.images.splice(this.images.indexOf(id), 1);
    });
  }

  async getImages(path: string): Promise<Array<string>> {
    const uri = pics.download;
    const config: AxiosRequestConfig = {
      params: { path },
    };
    return new Promise<Array<string>>((res, rej) => {
      this.$axios
        .get(uri, config)
        .then((imgs: AxiosResponse<Array<string> | string>) => {
          if (imgs.status === 200 && imgs.data != "Папка не найдена")
            res(imgs.data as Array<string>);
        })
        .catch((e: AxiosError) => {
          rej(e);
        });
    });
  }

  createImageList(): void {
    this.getImages(this.folder + "/origin").then(
      (imgs: Array<string> | string) => {
        if (imgs != "Папка не найдена") this.images = imgs as Array<string>;
      }
    );
  }

  mounted(): void {
    this.createImageList();
  }
}
